import Council1 from '../assets/images/council1.png';
import Council2 from '../assets/images/council2.png';
import Council3 from '../assets/images/council3.png';
import Council4 from '../assets/images/council4.png';
import Council5 from '../assets/images/council5.png';
import Council6 from '../assets/images/council6.png';
import Council7 from '../assets/images/council7.png';
import Council8 from '../assets/images/council8.png';
import Council9 from '../assets/images/council9.png';
import Council10 from '../assets/images/council10.png';
import Council11 from '../assets/images/council11.png';

export default [
  {
    img: Council11,
    name: 'Moruf Oseni',
    role: 'MD/CEO, Wema Bank',
    w: 'w-[184px]',
    h: 'h-[240px]'
  },
  {
    img: Council10,
    name: 'Oluwole Ajimisinmi',
    role: 'Executive Director, Lagos Business',
    w: 'w-[184px]',
    h: 'h-[240px]',
    role2: '(Chairman, Governing Council)'
  },
  {
    img: Council2,
    name: 'Ololade Ogungbenro',
    role: 'Divisional Head, Brands, People & Culture',
    role2: '(Executive Member)',
    w: 'w-[184px]',
    h: 'h-[240px]'
  },
  {
    img: Council1,
    name: 'Oluwatoyin Karienren',
    role: 'Chief Compliance Officer ',
    role2: '(Executive Member)',
    w: 'w-[184px]',
    h: 'h-[240px]'
  },
  {
    img: Council3,
    name: 'Tajudeen Bakare',
    role: 'Divisional Head, Operations & General Services',
    role2: '(Executive Member)',
    w: 'w-[184px]',
    h: 'h-[240px]'
  },
  {
    img: Council4,
    name: 'Kayode Osumah',
    role: 'Regional Manager, Lagos Mainland',
    role2: '(Executive Member)',
    w: 'w-[184px]',
    h: 'h-[240px]'
  },
  {
    img: Council5,
    name: 'Adeyemi Oshundiya',
    role: 'Chief Experience Officer',
    role2: '(Executive Member)',
    w: 'w-[184px]',
    h: 'h-[240px]'
  },
  {
    img: Council6,
    name: 'Bunmi Oladosu',
    role: 'Chief Financial Officer',
    role2: '(Executive Member)',
    w: 'w-[184px]',
    h: 'h-[240px]'
  },
  {
    img: Council7,
    name: 'Babatunde Mumuni',
    role: 'Chief Transformation Officer',
    role2: '(Executive Member)',
    w: 'w-[184px]',
    h: 'h-[240px]'
  },
  {
    img: Council8,
    name: 'Femi Akinfolarin',
    role: 'Head, Corporate Strategy, & Investor Relations',
    role2: '(Executive Member)',
    w: 'w-[184px]',
    h: 'h-[240px]'
  },
  {
    img: Council9,
    name: 'Oluwaferanmi Owolabi',
    role: 'Vice Chancellor, Purple Academy',
    w: 'w-[184px]',
    h: 'h-[240px]',
    role2: '(Secretary)'
  }
];
